import { Component, Input } from '@angular/core';

import { FormFieldBaseComponent } from 'src/app/shared/components/form-field-base/form-field-base.component';

@Component({
  selector: 'app-text-field',
  templateUrl: './text-field.component.html',
  styleUrls: ['./text-field.component.scss'],
})
export class TextFieldComponent<
  T extends number | string
> extends FormFieldBaseComponent<T> {
  @Input() type: string = 'text';
  @Input() min?: number | string = undefined;
  @Input() max?: number | string = undefined;
  @Input() step?: number | string = undefined;
  @Input() hint: string = '';
  @Input() icon?: string;
  @Input() tooltip?: string;
  @Input() showRequiredLabel = true;
  @Input() maxDecimals = 10000;

  onInputChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.onValueChange(target.value as T);
  }

  get showHint(): boolean {
    return (
      !!this.hint &&
      (this.control?.hasError('pattern') ||
        this.control?.hasError('notEmbeddable') ||
        this.control?.hasError(this.formFieldName))
    );
  }

  clearControl() {
    this.control.reset();
  }
}
